//@ts-check
import request from '../request';
/**
 * Get a list of files that match the path and extensions filters
 * @param {string} workspace
 * @param {string} path directory path, can contain '%' as wildcard
 * @param {string} extensions ex: '.imdb'
 */

export var searchFiles = function searchFiles(workspace, path, extensions) {
  // does not find files if path is not with backslashes
  path = path.split('/').join('\\');
  return request({
    url: '/backend/searchFiles2',
    query: {
      workspace: workspace,
      path: path,
      extensions: extensions
    }
  });
};
export default {
  searchFiles: searchFiles
};